import { Link } from "react-router-dom";
import { WaitlistForm } from "./WaitlistForm";

export const Footer = () => (
  <footer className="mt-24 border-t border-border bg-[#F0EDE5]" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-10 px-6 py-16 lg:grid-cols-4 lg:px-12">
      <div>
        <div className="font-serif text-2xl text-foreground">Alabama Lion's Mane Rabbitry</div>
        <p className="mt-3 text-sm leading-relaxed text-stone">
          A small, family-run Alabama rabbitry raising pedigreed Lion's Mane rabbits with care, conscience, and a love for the breed.
        </p>
        <div className="mt-5">
          <div className="section-label mb-2">Litter waitlist</div>
          <WaitlistForm testIdPrefix="footer-waitlist" />
        </div>
      </div>
      <div>
        <div className="section-label">Visit</div>
        <ul className="mt-4 space-y-2 text-sm text-foreground/80">
          <li>Local pickup in Alabama</li>
          <li>By appointment only</li>
          <li>Health-checked & pedigreed</li>
        </ul>
      </div>
      <div>
        <div className="section-label">Explore</div>
        <ul className="mt-4 space-y-2 text-sm">
          <li><Link to="/rabbits" className="link-underline" data-testid="footer-link-rabbits">Available Rabbits</Link></li>
          <li><Link to="/care-guide" className="link-underline" data-testid="footer-link-care">Care Guide</Link></li>
          <li><Link to="/guarantee" className="link-underline" data-testid="footer-link-guarantee">Health Guarantee</Link></li>
          <li><Link to="/contact" className="link-underline" data-testid="footer-link-contact">Contact</Link></li>
        </ul>
      </div>
      <div>
        <div className="section-label">Contact</div>
        <ul className="mt-4 space-y-2 text-sm text-foreground/80">
          <li>hello@alabamalionsmanerabbitry.com</li>
          <li>(256) 555-0142</li>
          <li>Northeast Alabama</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-border">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-2 px-6 py-6 text-xs text-stone lg:flex-row lg:items-center lg:px-12">
        <div>© {new Date().getFullYear()} Alabama Lion's Mane Rabbitry. All rights reserved.</div>
        <div>Operating in compliance with Alabama Department of Agriculture & Industries.</div>
      </div>
    </div>
  </footer>
);
